import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { LicenceService } from "@services/licence.service";
import { UiService } from "@services/ui.service";
import { Licence } from "@classes/licence/licence";


@Injectable()
export class LicenceResolver implements Resolve<Licence> {
    constructor(
        private licenceSrv: LicenceService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Licence> {
        const code = route.paramMap.get('code');

        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.licenceSrv.get(code)
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
